import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectDirectLinkParam,
  selectSelectedSession,
  selectSessionLoading,
} from './session.selectors';
import { Session } from './session.model';
import { SessionActions } from './session.actions';

@Injectable({
  providedIn: 'root',
})
export class SessionFacade {
  private readonly store: Store = inject(Store);

  public readonly selectedSession: Signal<Session | undefined> =
    this.store.selectSignal(selectSelectedSession);
  public readonly sessionLoading: Signal<boolean> =
    this.store.selectSignal(selectSessionLoading);
  public readonly directLinkParam: Signal<string | undefined> =
    this.store.selectSignal(selectDirectLinkParam);

  public loadSession(): void {
    this.store.dispatch(SessionActions.loadSession());
  }
}
